import axios from '../utils/axios';

export default function getUnmappedRecruiters(adminId, params) {
    return axios.get(`/admin/${adminId}/unmapped-recruiters`, { params });
};
